<template>
  <!-- <transition name="slide-fade">
    <div class="drawer-content-wrapper" :style="{width}" v-if="visible">
      <div class="drawer-content">
        <div class="drawer-wrapper-body">
          <div class="drawer-header" v-if="title">
            <a>
              <a-icon type="arrow-left" style="drawer-header-icon" />
            </a>
            <div class="drawer-title">{{title}}</div>
          </div>
          <div class="drawer-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>-->
  <div class="drawer-content-wrapper" :style="{bottom,background:bgc}" v-if="visible">
    <div class="drawer-content" :style="contentStyle">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolDrawer",
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    bottom: {
      default: "62px",
      type: String,
    },
    bgc:{
      default: "rgba(51, 51, 51, 1)",
      type: String,
    },
    contentStyle:{
      type: String
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
// .slide-fade-enter-active {
//   transition: all 0.5s ease;
// }

// .slide-fade-leave-active {
//   transition: all 0.5s;
// }

// // .slide-fade-enter
// // /* .slide-fade-leave-active for below version 2.1.8 */ {
// //   transform: translateX(-210px);
// //   opacity: 0;
// // }

// .slide-fade-enter, .slide-fade-leave-to
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateX(-200px);
//   opacity: 0;
// }

.drawer-content-wrapper {
  width: 100%;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.5s;

  .drawer-content {
    width: 100%;
    height: 100%;

    position: relative;
    z-index: 1;
    overflow: auto;
    background-clip: padding-box;
    border: 0;
  }
}

.tool-bg {
  height: 200px;
  width: 100%;
  background-color: rgba(163, 163, 163, 0.4);
}
</style>